import type { ChangeEventHandler } from "react";
import { FieldShell } from "./FieldShell";
import { fieldIds, inputClass, resolveFieldState } from "./fieldStyles";

interface TextAreaProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  hint?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  containerClassName?: string;
  children?: never;
}

export function TextArea({ id, label, value, onChange, error, hint, required, readOnly, placeholder, rows = 3, maxLength, containerClassName }: TextAreaProps) {
  const ids = fieldIds(id, error, hint);
  const state = resolveFieldState({ error, readOnly });

  const handleChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => onChange(event.currentTarget.value);

  return (
    <FieldShell id={id} label={label} required={required} hint={hint} hintId={ids.hintId} error={error} errorId={ids.errorId} containerClassName={containerClassName}>
      <textarea
        id={id}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        readOnly={readOnly}
        aria-required={required || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={ids.describedBy}
        className={`${inputClass(state)} resize-y`}
      />
    </FieldShell>
  );
}
